import { queryOptions } from "@tanstack/react-query";

import {
	apiUrl,
	appFetch,
	ensureOk,
	fetchJson,
	toApiError,
} from "@workspace/base-api";

export const settingsApi = {
	async get<T>(tenant: string, id: string, venueId?: string | undefined) {
		const url = new URL(
			`/settings/${id}${venueId ? `/${venueId}` : ""}`,
			apiUrl,
		);

		return await fetchJson<T>(url.toString(), {
			headers: {
				tenant: tenant || "",
			},
		});
	},
	getOptions<T>(tenant: string, id: string, venueId?: string | undefined) {
		return queryOptions({
			queryKey: [tenant, venueId, "settings", id],
			queryFn: () => settingsApi.get<T>(tenant, id, venueId),
		});
	},
	async post<T>(
		tenant: string,
		id: string,
		data: T,
		venueId?: string | undefined,
	) {
		const url = new URL(
			`/settings/${id}${venueId ? `/${venueId}` : ""}`,
			apiUrl,
		);

		try {
			const response = await ensureOk(
				await appFetch(url.toString(), {
					headers: {
						tenant: tenant || "",
					},
					method: "POST",
					body: JSON.stringify(data),
				}),
			);

			return {
				success: true as const,
				response,
			};
		} catch (e: unknown) {
			return await toApiError(e, "Failed to save settings");
		}
	},
	postOptions<T>(tenant: string, id: string, venueId?: string | undefined) {
		return {
			mutationKey: [tenant, venueId, id, "post"],
			mutationFn: (data: T) => settingsApi.post(tenant, id, data, venueId),
		};
	},
};
